import { useMemo } from "react";

const labels = {
  English: {
    Jobs: "Jobs",
    ActiveJobs: "Active Jobs",
    JobId: "Job ID",
    JobName: "Job Name",
    Vacancies: "Vacancies",
    vacancy: "Vacancies",
    Department: "Department",
    HiringManager: "Hiring Manager",
    PostedDate: "Posted Date",
    Actions: "Actions",
    Edit: "Edit",
    Delete: "Delete",
    AddVacancy: "Add Vacancy",
    ManageAndTrackPositions: "Manage and track your open positions.",
    SearchJobName: "Search job name...",
    JobNotFound: "Job not found",
    NoActiveJobs: "No active jobs record",
    editJob: "Edit Job",
    updateJobDetails: "Update the job details below.",
    department: "Department",
    hiringManager: "Hiring Manager",
    firstName: "First Name",
    lastName: "Last Name",
    updateJob: "Update Job",
    selectDepartment: "Select Department",
    ViewManageTrack:
      "View, manage, and track open job positions. You can edit details or delete listings as needed.",    confirmDelete:
      "Are you sure you want to delete this job? Deleting this job will also remove all associated applicants and their reference records.",
    yes: "Yes",
    no: "No",
    createNewJob: "Create New",
    job: "Vacancy",
    addNewJob: "Add a new vacancy. Please fill out the details below.",
    jobDetails: "Job Details",
    fillRequired: "* Fill in the required information",
    applicantDetails: "Applicant Details",
    referenceFormat: "Reference Format",
    questionName: "Question Name",
    applicant: "Applicant",
    email: "Email",
    cancel: "Cancel",
    proceed: "Proceed",
    numReferees: "No. of Referees",
    backWarning:
      "Are you sure you want to go back? Your progress will be lost.",
    noCustomQuestions: "No custom questions available",
    hrHatch: "Snappcheck",
    custom: "Custom Questionnaire",
    standardFormat: "Standard Format",
    managementFormat: "Management Format",
    executiveFormat: "Executive Format",
    errors: {
      jobNameLength: "Job name must be at least 2 characters.",
      firstNameLength: "First name must be at least 2 characters.",
      lastNameLength: "Last name must be at least 2 characters.",
      vacancyMin: "Vacancies must be at least 1.",
      vacancyGreater: function (vacancies) {
        return `The new vacancy number must be greater than the current vacancy count (${vacancies}).`;
      },
      refereesMin: "Number of referees must be at least 1.",
    },
    staticContent: {
      existing: "(Existing)",
      emailPlaceholder: "applicant@example.com",
      loading: "Loading...",
      noApplicants: "No applicants available for this job.",
    },
    departments: {
      sales: "Sales",
      marketing: "Marketing",
      customerService: "Customer Service",
      hr: "Human Resources (HR)",
      finance: "Finance",
      accounting: "Accounting",
      operations: "Operations",
      it: "IT (Information Technology)",
      legal: "Legal",
      administration: "Administration",
      productDevelopment: "Product Development",
      rAndD: "Research and Development (R&D)",
      logistics: "Logistics, Supply Chain & Procurement",
      businessDev: "Business Development",
      pr: "Public Relations (PR)",
      design: "Design",
      compliance: "Compliance",
      riskManagement: "Risk Management",
    },
  },
  Japanese: {
    Jobs: "求人",
    ActiveJobs: "求人",
    JobId: "求人ID",
    JobName: "職種名",
    Vacancies: "求人情報",
    Department: "部門",
    HiringManager: "採用担当者",
    PostedDate: "掲載日",
    Actions: "操作",
    Edit: "編集",
    Delete: "削除",
    AddVacancy: "追加",
    ManageAndTrackPositions: "空いているポジションを管理および追跡します。",
    SearchJobName: "職種名を検索...",
    JobNotFound: "求人が見つかりません",
    NoActiveJobs: "アクティブな求人情報はありません",
    editJob: "ジョブを編集",
    updateJobDetails: "以下のジョブ詳細を更新してください。",
    department: "部署",
    hiringManager: "採用担当者",
    firstName: "名",
    lastName: "姓",
    updateJob: "更新",
    selectDepartment: "部署を選択",
    ViewManageTrack:
      "公開されている求人情報を表示、管理、追跡できます。詳細を編集したり、必要に応じてリストを削除したりできます。",    confirmDelete:
      "このジョブを削除してもよろしいですか？このジョブを削除すると、関連する応募者とその参照記録もすべて削除されます。",
    yes: "はい",
    no: "いいえ",
    createNewJob: "新しい求人を作成",
    job: "求人",
    addNewJob: "新しい求人を追加します。以下の詳細を入力してください。",
    jobDetails: "職務内容",
    fillRequired: "* 必須情報を入力してください",
    jobName: "職種名",
    vacancy: "空き",
    applicantDetails: "応募者詳細",
    referenceFormat: "リファレンス形式",
    questionName: "質問名",
    applicant: "応募者",
    email: "メールアドレス",
    cancel: "キャンセル",
    proceed: "続行",
    numReferees: "推薦者数",
    backWarning: "前のページに戻りますか？入力内容は失われます。",
    noCustomQuestions: "カスタム質問はありません",
    hrHatch: "HRハッチ",
    custom: "カスタムアンケート",
    standardFormat: "標準フォーマット",
    managementFormat: "管理職フォーマット",
    executiveFormat: "エグゼクティブフォーマット",
    errors: {
      jobNameLength: "職種名は2文字以上である必要があります。",
      firstNameLength: "名前は2文字以上である必要があります。",
      lastNameLength: "姓は2文字以上である必要があります。",
      vacancyMin: "募集人数は1人以上である必要があります。",
      vacancyGreater: function (vacancies) {
        return `新しい募集人数は現在の募集人数（${vacancies}）より多く設定してください。`;
      },
      refereesMin: "推薦者数は1人以上である必要があります。",
    },
    staticContent: {
      existing: "(既存)",
      emailPlaceholder: "応募者@example.com",
      loading: "読み込み中...",
      noApplicants: "この求人に応募者はありません。",
    },
    departments: {
      sales: "営業",
      marketing: "マーケティング",
      customerService: "カスタマーサービス",
      hr: "人事",
      finance: "財務",
      accounting: "経理",
      operations: "運営",
      it: "IT",
      legal: "法務",
      administration: "総務",
      productDevelopment: "製品開発",
      rAndD: "研究開発",
      logistics: "物流・調達",
      businessDev: "事業開発",
      pr: "広報",
      design: "デザイン",
      compliance: "コンプライアンス",
      riskManagement: "リスク管理",
    },
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
